import { adminAreaConstants } from "./adminarea.constants";

const initialState = {
    audit: {
        authDataChanges: [],
        integrationsChanges: [],
        organizationChanges: [],
        usersChanges: [],
        auditedOrganization: {},
    },
};

export function adminArea(state = { ...initialState }, action) {
    let index;
    let fees;

    switch (action.type) {
        case adminAreaConstants.GET_ALL_ORGANIZATIONS_REQUEST:
            return {
                ...state,
                organizationsLoading: true,
                organizations: [],
                // filterProperties: (action.filterProperties !== null ? action.filterProperties : this.state.filterProperties),
            };

        case adminAreaConstants.GET_ALL_ORGANIZATIONS_SUCCESS:
            let filterProperties = state.filterProperties;
            filterProperties.currentPage = action.result.currentPage;
            return {
                ...state,
                organizationsLoading: false,
                organizations: action.result.content,
                totalPages: action.result.totalPages,
                totalElements: action.result.totalElements,
                itemsPerPage: action.result.itemsPerPage,
                filterProperties: filterProperties,
                errorMessage: null,
            };

        case adminAreaConstants.GET_ALL_ORGANIZATIONS_FAILURE:
            return {
                ...state,
                errorMessage: action.errorMessage,
                organizationsLoading: false,
                organizations: [],
            };

        case adminAreaConstants.GET_ALL_SELECTABLE_ORGANIZATIONS_REQUEST:
            return {
                ...state,
                selectableOrganizationsLoading: true,
                errorMessage: null,
                selectableOrganizations: [],
            };

        case adminAreaConstants.GET_ALL_SELECTABLE_ORGANIZATIONS_SUCCESS:
            return {
                ...state,
                selectableOrganizations: action.result,
                selectableOrganizationsLoading: false,
            };

        case adminAreaConstants.GET_ALL_SELECTABLE_ORGANIZATIONS_FAILURE:
            return {
                ...state,
                selectableOrganizationsLoading: false,
                errorMessage: action.errorMessage,
            };

        case adminAreaConstants.GET_ADMIN_AREA_ORGANIZATION_REQUEST:
            return {
                ...state,
                organizationLoading: true,
                organization: null,
                editOrganization: null,
                shopifyOrderHistory: undefined,
                stripeChargesHistory: undefined,
            };

        case adminAreaConstants.GET_ADMIN_AREA_ORGANIZATION_SUCCESS:
            return {
                ...state,
                organizationLoading: false,
                organization: action.organization,
                editOrganization: action.organization,
            };

        case adminAreaConstants.GET_ADMIN_AREA_ORGANIZATION_FAILURE:
            return {
                ...state,
                errorMessage: action.errorMessage,
                organizationLoading: false,
                organization: null,
                editOrganization: null,
            };

        case adminAreaConstants.SET_ADMIN_AREA_EDIT_ORGANIZATION:
            return {
                ...state,
                editOrganization: action.organization,
            };

        case adminAreaConstants.RESET_EDIT_ORGANIZATION_TO_CONFIGURATION:
            return {
                ...state,
                editOrganization: state.organization,
            };

        case adminAreaConstants.SET_INITIAL_ADMIN_AREA_STATE:
            return {
                ...state,
                loading: action.state.loading,
                editOrganization: action.state.editOrganization,
            };

        case adminAreaConstants.GET_ORGANIZATIONS_WITH_BILLING_ENABLED_REQUEST:
            return {
                ...state,
                billingOrganizationsLoading: true,
                configurations: [],
            };

        case adminAreaConstants.GET_ORGANIZATIONS_WITH_BILLING_ENABLED_SUCCESS:
            return {
                ...state,
                billingOrganizationsLoading: false,
                configurations: action.configurations,
            };
        case adminAreaConstants.GET_ORGANIZATIONS_WITH_BILLING_ENABLED_FAILURE:
            return {
                ...state,
                billingOrganizationsLoading: false,
                configurations: [],
            };

        case adminAreaConstants.DELETE_ADMIN_AREA_ORGANIZATION_REQUEST:
            return {
                ...state,
                deletionErrorMessage: undefined,
                deletionLoading: true,
            };

        case adminAreaConstants.DELETE_ADMIN_AREA_ORGANIZATION_SUCCESS:
            let organizations = state.organizations;
            if (organizations && organizations.length > 0) {
                index = organizations.findIndex((item) => {
                    return item.externalUUID === action.organization.externalUUID;
                });

                if (index > -1) {
                    organizations.splice(index, 1);
                }
            }

            return {
                ...state,
                organizations: organizations,
                deletionErrorMessage: undefined,
                deletionLoading: false,
                deletionModal: false,
                totalElements: state.totalElements - 1,
            };

        case adminAreaConstants.DELETE_ADMIN_AREA_ORGANIZATION_FAILURE:
            return {
                ...state,
                deletionErrorMessage: action.errorMessage,
                deletionLoading: false,
            };

        case adminAreaConstants.GET_ADMIN_AREA_USERS_REQUEST:
            return {
                ...state,
                usersLoading: true,
                users: [],
            };

        case adminAreaConstants.GET_ADMIN_AREA_USERS_SUCCESS:
            return {
                ...state,
                usersLoading: false,
                users: action.users,
            };

        case adminAreaConstants.GET_ADMIN_AREA_USER_BY_FILTER_REQUEST:
            return {
                ...state,
                usersLoading: true,
                users: [],
                // userFilterProperties: (action.userFilterProperties !== null ? action.userFilterProperties : this.state.userFilterProperties),
            };

        case adminAreaConstants.GET_ADMIN_AREA_USER_BY_FILTER_SUCCESS:
            const response = action?.result;
            if (!response) {
                return {
                    ...state,
                    usersLoading: false,
                    users: [],
                };
            }

            let userFilterProperties = { ...state.userFilterProperties };
            userFilterProperties.currentPage = response.currentPage ?? 1;
            return {
                ...state,
                usersLoading: false,
                users: response.content || [],
                totalPages: response.totalPages ?? 0,
                totalElements: response.totalElements ?? 0,
                itemsPerPage: response.itemsPerPage ?? 10,
                userFilterProperties,
                errorMessage: null,
            };

        case adminAreaConstants.GET_ADMIN_AREA_USER_BY_FILTER_FAILURE:
            return {
                ...state,
                usersLoading: false,
                errorMessage: action.errorMessage,
            };

        case adminAreaConstants.GET_ADMIN_AREA_USERS_FAILURE:
            return {
                ...state,
                errorMessage: action.errorMessage,
                usersLoading: false,
                users: [],
            };

        case adminAreaConstants.GET_ADMIN_AREA_USER_REQUEST:
            return {
                ...state,
                loading: true,
                user: [],
            };

        case adminAreaConstants.GET_ADMIN_AREA_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                user: action.user,
            };

        case adminAreaConstants.GET_ADMIN_AREA_USER_FAILURE:
            return {
                ...state,
                errorMessage: action.errorMessage,
                loading: false,
                user: [],
            };

        case adminAreaConstants.DELETE_ADMIN_AREA_USER_REQUEST:
            return {
                ...state,
                deletionErrorMessage: undefined,
                deletionLoading: true,
            };

        case adminAreaConstants.DELETE_ADMIN_AREA_USER_SUCCESS:
            let users = state.users;
            index = users.findIndex((item) => {
                return item.externalUUID === action.user.externalUUID;
            });
            if (index > -1) {
                users.splice(index, 1);
            }
            return {
                ...state,
                users: users,
                deletionErrorMessage: undefined,
                deletionLoading: false,
                deletionModal: false,
            };

        case adminAreaConstants.DELETE_ADMIN_AREA_USER_FAILURE:
            return {
                ...state,
                deletionErrorMessage: action.errorMessage,
                deletionLoading: false,
                deletionModal: false,
            };

        case adminAreaConstants.UPDATE_ADMIN_AREA_ORGANIZATION_REQUEST:
            return {
                ...state,
                subloading: true,
                errorMessage: undefined,
            };

        case adminAreaConstants.UPDATE_ADMIN_AREA_ORGANIZATION_SUCCESS:
            let org;
            if (action.organization.response) {
                org = action.organization.response;
            } else {
                org = action.organization;
            }
            return {
                ...state,
                subloading: false,
                organization: org,
                editOrganization: org,
            };

        case adminAreaConstants.UPDATE_ADMIN_AREA_ORGANIZATION_FAILURE:
            return {
                ...state,
                subloading: false,
                errorMessage: action.errorMessage,
                user: [],
            };

        case adminAreaConstants.UPDATE_ADMIN_AREA_USER_REQUEST:
            return {
                ...state,
                subloading: true,
                errorMessage: undefined,
            };

        case adminAreaConstants.UPDATE_ADMIN_AREA_USER_SUCCESS:
            return {
                ...state,
                subloading: false,
                user: action.user,
            };
        case adminAreaConstants.REVOKE_ADMIN_AREA_USER_LAST_PASSWORD_CHANGE_REQUEST:
            return {
                ...state,
                revokeLastPasswordChangeLoading: true,
                errorMessage: undefined,
            };
        case adminAreaConstants.REVOKE_ADMIN_AREA_USER_LAST_PASSWORD_CHANGE_SUCCESS:
            return {
                ...state,
                revokeLastPasswordChangeLoading: false,
                user: action.user,
            };

        case adminAreaConstants.REVOKE_ADMIN_AREA_USER_LAST_PASSWORD_CHANGE_FAILURE:
            return {
                ...state,
                revokeLastPasswordChangeLoading: false,
                errorMessage: action.errorMessage,
            };

        case adminAreaConstants.CREATE_NEW_RESET_PASSWORD_LINK_FAILURE:
            return {
                ...state,
                resetPasswordLinkLoading: false,
                errorMessage: action.errorMessage,
            };

        case adminAreaConstants.CREATE_NEW_RESET_PASSWORD_LINK_REQUEST:
            return {
                ...state,
                resetPasswordLinkLoading: true,
                errorMessage: undefined,
            };

        case adminAreaConstants.CREATE_NEW_RESET_PASSWORD_LINK_SUCCESS:
            return {
                ...state,
                resetPasswordLinkLoading: false,
                user: action.user,
            };

        case adminAreaConstants.UPDATE_ADMIN_AREA_USER_FAILURE:
            return {
                ...state,
                subloading: false,
                errorMessage: action.errorMessage,
                user: [],
            };

        case adminAreaConstants.TOGGLE_SHOPIFY_BASIC_COUNT_MODAL_FOR_ORGANIZATION:
            return {
                ...state,
                organizationShopifyBasicCountModal: !state.organizationShopifyBasicCountModal,
                selectedOrganizationUUID: action.organizationUUID,
                integrationCount: null,
            };

        case adminAreaConstants.TOGGLE_SHOPIFY_ADVANCED_COUNT_MODAL_FOR_ORGANIZATION:
            return {
                ...state,
                organizationShopifyAdvancedCountModal: !state.organizationShopifyAdvancedCountModal,
                selectedOrganizationUUID: action.organizationUUID,
            };

        case adminAreaConstants.TOGGLE_STRIPE_CHARGES_MODAL_FOR_ORGANIZATION:
            return {
                ...state,
                organizationStripeChargesModal: !state.organizationStripeChargesModal,
                selectedOrganizationUUID: action.organizationUUID,
            };

        case adminAreaConstants.TOGGLE_SHOPIFY_PAYMENTS_MODAL_FOR_ORGANIZATION:
            return {
                ...state,
                organizationShopifyPaymentsModal: !state.organizationShopifyPaymentsModal,
                selectedOrganizationUUID: action.organizationUUID,
            };

        case adminAreaConstants.CHARGE_ORGANIZATIONS_REQUEST:
            return {
                ...state,
                billingLoading: true,
                billingSuccessMessage: undefined,
                billingErrorMessage: undefined,
            };

        case adminAreaConstants.CHARGE_ORGANIZATIONS_SUCCESS:
            return {
                ...state,
                billingLoading: false,
                billingSuccessMessage: action.successMessage,
            };

        case adminAreaConstants.CHARGE_ORGANIZATIONS_FAILURE:
            return {
                ...state,
                billingLoading: false,
                billingErrorMessage: action.errorMessage,
            };

        case adminAreaConstants.CLEAR_BILLING_DATA:
            return {
                ...state,
                billingLoading: false,
                billingErrorMessage: undefined,
                billingSuccessMessage: undefined,
            };

        case adminAreaConstants.GET_APP_STORE_ORGANIZATIONS_REQUEST:
            return {
                ...state,
                appStoreOrganizationLoading: true,
                appStoreOrganizations: undefined,
                filterProperties: action.filterProperties
                    ? {
                          name: action.filterProperties.name,
                          email: action.filterProperties.email,
                          shopifyDomain: action.filterProperties.shopifyDomain,
                          authorized: action.filterProperties.authorized,
                      }
                    : {
                          name: null,
                          email: null,
                          shopifyDomain: null,
                          authorized: null,
                      },
                errorMessage: null,
            };

        case adminAreaConstants.GET_APP_STORE_ORGANIZATIONS_SUCCESS:
            return {
                ...state,
                appStoreOrganizationLoading: false,
                appStoreOrganizations: action.result,
            };

        case adminAreaConstants.GET_APP_STORE_ORGANIZATIONS_FAILURE:
            return {
                ...state,
                appStoreOrganizationLoading: false,
                errorMessage: action.errorMessage,
            };

        case adminAreaConstants.RESET_TO_REGULAR_ORGANIZATION_REQUEST:
            return {
                ...state,
                appStoreOrganizationLoading: true,
            };

        case adminAreaConstants.RESET_TO_REGULAR_ORGANIZATION_SUCCESS:
            return {
                ...state,
                successMessage:
                    "Die Appstore-Organisation wurde erfolgreich zu einer normalen Organisation umgewandelt.",
                appStoreOrganizationLoading: false,
            };

        case adminAreaConstants.RESET_TO_REGULAR_ORGANIZATION_FAILURE:
            return {
                ...state,
                errorMessage: action.errorMessage,
                appStoreOrganizationLoading: false,
            };

        case adminAreaConstants.GET_ALL_APPLICATIONS_REQUEST:
            return {
                ...state,
                loading: true,
                allApplications: null,
            };

        case adminAreaConstants.GET_ALL_APPLICATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                allApplications: action.result,
            };

        case adminAreaConstants.GET_ALL_APPLICATIONS_FAILURE:
            return {
                ...state,
                loading: false,
            };

        case adminAreaConstants.SET_FILTER_PROPERTIES:
            return {
                ...state,
                filterProperties: action.filterProperties,
            };

        case adminAreaConstants.SET_USER_FILTER_PROPERTIES:
            return {
                ...state,
                userFilterProperties: action.userFilterProperties,
            };

        case adminAreaConstants.CLEAR_DELETION_ERROR_MESSAGES:
            return {
                ...state,
                deletionErrorMessage: null,
            };

        case adminAreaConstants.CLEAR_ERROR_MESSAGE:
            return {
                ...state,
                errorMessage: undefined,
                modalErrorMessage: null,
            };

        case adminAreaConstants.OPEN_DETAILED_PAGE:
            return {
                ...state,
            };

        // **********************************

        case adminAreaConstants.TOGGLE_STRIPE_BILLING_MODAL_FOR_ORGANIZATION:
            return {
                ...state,
                organizationStripeBillingModal: !state.organizationStripeBillingModal,
                selectedOrganizationUUID: action.organizationUUID,
            };

        case adminAreaConstants.TOGGLE_CHARGEBEE_MODAL_FOR_ORGANIZATION:
            return {
                ...state,
                organizationChargebeeModal: !state.organizationChargebeeModal,
                selectedOrganizationUUID: action.organizationUUID,
            };

        case adminAreaConstants.TOGGLE_WOO_COMMERCE_ORDERS_MODAL_FOR_ORGANIZATION:
            return {
                ...state,
                organizationWooCommerceBasicCountModal: !state.organizationWooCommerceBasicCountModal,
                selectedOrganizationUUID: action.organizationUUID,
            };

        case adminAreaConstants.TOGGLE_WOO_COMMERCE_ORDERS_ADVANCED_MODAL_FOR_ORGANIZATION:
            return {
                ...state,
                organizationWooCommerceAdvancedCountModal: !state.organizationWooCommerceAdvancedCountModal,
                selectedOrganizationUUID: action.organizationUUID,
            };

        case adminAreaConstants.GET_CHARGEBEE_AUTOSETUP_MESSAGES_REQUEST:
            return {
                ...state,
                chargebeeAutoSetupLoading: true,
                chargebeeAutoSetupErrorMessage: null,
                chargebeeAutoSetupMessages: null,
            };

        case adminAreaConstants.GET_CHARGEBEE_AUTOSETUP_MESSAGES_SUCCESS:
            return {
                ...state,
                chargebeeAutoSetupLoading: false,
                chargebeeAutoSetupMessages: action.result,
            };

        case adminAreaConstants.GET_CHARGEBEE_AUTOSETUP_MESSAGES_FAILURE:
            return {
                ...state,
                chargebeeAutoSetupLoading: false,
                chargebeeAutoSetupErrorMessage: action.errorMessage,
            };

        case adminAreaConstants.GET_AMAZON_PAYOUT_FEES_REQUEST:
            return {
                ...state,
                amazonPayoutFeesLoading: true,
                modalErrorMessage: undefined,
                amazonPayoutFees: null,
            };

        case adminAreaConstants.GET_AMAZON_PAYOUT_FEES_SUCCESS:
            return {
                ...state,
                amazonPayoutFeesLoading: false,
                amazonPayoutFees: action.result,
            };

        case adminAreaConstants.GET_AMAZON_PAYOUT_FEES_FAILURE:
            return {
                ...state,
                amazonPayoutFeesLoading: false,
                modalErrorMessage: action.errorMessage,
            };

        case adminAreaConstants.CREATE_AMAZON_PAYOUT_FEE_REQUEST:
            return {
                ...state,
                amazonPayoutFeeCreationLoading: true,
                createdAmazonPayoutFee: undefined,
                modalErrorMessage: null,
            };

        case adminAreaConstants.CREATE_AMAZON_PAYOUT_FEE_SUCCESS:
            fees = state.amazonPayoutFees;
            fees.unshift(action.result);
            fees.sort((a, b) =>
                a.amazonOriginalName.toLowerCase() > b.amazonOriginalName.toLowerCase()
                    ? 1
                    : a.amazonOriginalName.toLowerCase() < b.amazonOriginalName.toLowerCase()
                      ? -1
                      : 0
            );
            return {
                ...state,
                amazonPayoutFeeCreationLoading: false,
                amazonPayoutFees: fees,
                amazonPayoutFee: action.result,
            };

        case adminAreaConstants.CREATE_AMAZON_PAYOUT_FEE_FAILURE:
            return {
                ...state,
                amazonPayoutFeeCreationLoading: false,
                modalErrorMessage: action.errorMessage,
            };

        case adminAreaConstants.EDIT_AMAZON_PAYOUT_FEE_REQUEST:
            return {
                ...state,
                amazonPayoutFeeEditLoading: true,
                createdAmazonPayoutFee: undefined,
                modalErrorMessage: null,
            };

        case adminAreaConstants.EDIT_AMAZON_PAYOUT_FEE_SUCCESS:
            fees = state.amazonPayoutFees;
            let updatedFee = action.result;
            index = fees.findIndex((fee) => fee.externalUUID === updatedFee.externalUUID);
            if (index > -1) {
                fees[index] = updatedFee;
            }
            fees.sort((a, b) =>
                a.amazonOriginalName.toLowerCase() > b.amazonOriginalName.toLowerCase()
                    ? 1
                    : a.amazonOriginalName.toLowerCase() < b.amazonOriginalName.toLowerCase()
                      ? -1
                      : 0
            );
            return {
                ...state,
                amazonPayoutFeeEditLoading: false,
                amazonPayoutFees: fees,
                createdAmazonPayoutFee: action.result,
            };

        case adminAreaConstants.EDIT_AMAZON_PAYOUT_FEE_FAILURE:
            return {
                ...state,
                amazonPayoutFeeEditLoading: false,
                modalErrorMessage: action.errorMessage,
            };

        case adminAreaConstants.DELETE_AMAZON_PAYOUT_FEE_REQUEST:
            return {
                ...state,
                amazonPayoutFeeDeletionLoading: true,
                modalErrorMessage: null,
            };

        case adminAreaConstants.DELETE_AMAZON_PAYOUT_FEE_SUCCESS:
            fees = state.amazonPayoutFees;
            index = fees.findIndex((fee) => fee.externalUUID === action.result.externalUUID);
            if (index > -1) {
                fees.splice(index, 1);
            }
            return {
                ...state,
                amazonPayoutFees: fees,
                amazonPayoutFeeDeletionLoading: false,
            };

        case adminAreaConstants.DELETE_AMAZON_PAYOUT_FEE_FAILURE:
            return {
                ...state,
                amazonPayoutFeeDeletionLoading: false,
                modalErrorMessage: action.errorMessage,
            };

        case adminAreaConstants.CLEAR_BMF_DATA:
            return {
                ...state,
                bmfErrorMessage: undefined,
                bmfExchangeRates: null,
            };

        case adminAreaConstants.GET_ADMIN_THREAD_DUMP_REQUEST:
            return {
                ...state,
                threadDumpLoading: true,
                threadDumpErrorMessage: undefined,
            };

        case adminAreaConstants.GET_ADMIN_THREAD_DUMP_SUCCESS:
            return {
                ...state,
                threadDumpLoading: false,
                threadDump: action.result,
            };

        case adminAreaConstants.GET_ADMIN_THREAD_DUMP_FAILURE:
            return {
                ...state,
                threadDumpLoading: false,
                threadDumpErrorMessage: action.errorMessage,
            };

        case adminAreaConstants.STOP_THREAD_DUMP_REQUEST:
            return {
                ...state,
                stopThreadLoading: true,
                threadDumpLoading: true,
                threadDumpErrorMessage: undefined,
            };

        case adminAreaConstants.STOP_THREAD_DUMP_SUCCESS:
            return {
                ...state,
                stopThreadLoading: false,
                threadDumpLoading: false,
                threadDump: action.result,
            };

        case adminAreaConstants.STOP_THREAD_DUMP_FAILURE:
            return {
                ...state,
                stopThreadLoading: false,
                threadDumpLoading: false,
                threadDumpErrorMessage: action.errorMessage,
            };

        case adminAreaConstants.GET_USER_LOGIN_STATISTICS_REQUEST:
            return {
                ...state,
                userLoginStatisticsLoading: true,
                userLoginStatisticsErrorMessage: undefined,
                userLoginStatistics: null,
            };

        case adminAreaConstants.GET_USER_LOGIN_STATISTICS_SUCCESS:
            return {
                ...state,
                userLoginStatisticsLoading: false,
                userLoginStatistics: action.result,
            };

        case adminAreaConstants.GET_USER_LOGIN_STATISTICS_FAILURE:
            return {
                ...state,
                userLoginStatisticsLoading: false,
                userLoginStatisticsErrorMessage: action.errorMessage,
            };

        case adminAreaConstants.VALIDATE_OR_REFRESH_WEBHOOKS_REQUEST:
            return {
                ...state,
                validationLoading: true,
            };

        case adminAreaConstants.VALIDATE_OR_REFRESH_WEBHOOKS_SUCCESS:
            index = state.configurations.findIndex(
                (configuration) => configuration.externalUUID === action.result.configurationId
            );

            let updatedConfig = state.configurations[index];
            updatedConfig.webhookFailingIndicator = action.result.result;

            if (index >= 0) {
                state.configurations[index] = updatedConfig;
            }

            return {
                ...state,
                validationLoading: false,
                configurations: state.configurations,
            };

        case adminAreaConstants.VALIDATE_OR_REFRESH_WEBHOOKS_FAILURE:
            return {
                ...state,
                validationLoading: false,
                errorMessage: action.result.error,
            };

        case adminAreaConstants.CONFIGURATION_CATCHUP_START_REQUEST:
            return {
                ...state,
                validationLoading: true,
            };

        case adminAreaConstants.CONFIGURATION_CATCHUP_START_SUCCESS:
            return {
                ...state,
                validationLoading: false,
                catchupStartedMessage: "Das Update wurde gestartet",
            };

        case adminAreaConstants.CONFIGURATION_CATCHUP_START_FAILURE:
            return {
                ...state,
                validationLoading: false,
                catchupErrorMessage: action.result,
            };

        case adminAreaConstants.CONFIGURATION_CATCHUP_START_CLEANUP:
            return {
                ...state,
                validationLoading: false,
                catchupStartedMessage: null,
            };

        case adminAreaConstants.RECREATE_EXISTING_DOCUMENTS_REQUEST:
            return {
                ...state,
                validationLoading: false,
                recreatingDocsMessage: null,
            };

        case adminAreaConstants.RECREATE_EXISTING_DOCUMENTS_SUCCESS:
            return {
                ...state,
                validationLoading: false,
                recreatingDocsMessage: action.result,
            };

        case adminAreaConstants.RECREATE_EXISTING_DOCUMENTS_FAILURE:
            return {
                ...state,
                validationLoading: false,
                recreatingDocsMessage: action.result,
            };

        case adminAreaConstants.RECREATE_ALL_DOCUMENTS_REQUEST:
            return {
                ...state,
                validationLoading: false,
                recreatingDocsMessage: null,
            };

        case adminAreaConstants.RECREATE_ALL_DOCUMENTS_SUCCESS:
            return {
                ...state,
                validationLoading: false,
                recreatingDocsMessage: action.result,
            };

        case adminAreaConstants.RECREATE_ALL_DOCUMENTS_FAILURE:
            return {
                ...state,
                validationLoading: false,
                recreatingDocsMessage: action.result,
            };

        case adminAreaConstants.RECREATE_DOCUMENTS_CLEANUP:
            return {
                ...state,
                validationLoading: false,
                recreatingDocsMessage: null,
            };

        case adminAreaConstants.DOWNLOAD_ALL_DOCUMENTS_REQUEST:
            return {
                ...state,
                validationLoading: true,
            };

        case adminAreaConstants.DOWNLOAD_ALL_DOCUMENTS_SUCCESS:
            return {
                ...state,
                validationLoading: false,
                catchupStartedMessage: "Der Download wurde gestartet",
            };

        case adminAreaConstants.DOWNLOAD_ALL_DOCUMENTS_FAILURE:
            return {
                ...state,
                validationLoading: false,
                catchupErrorMessage: action.result,
            };

        case adminAreaConstants.TOGGLE_ORDER_IMPORT_MODAL:
            return {
                ...state,
                orderImportModalOpen: !state.orderImportModalOpen,
            };

        case adminAreaConstants.TOGGLE_SHOW_AUTO_SETUP_MODAL:
            return {
                ...state,
                showAutoSetupModalOpen: !state.showAutoSetupModalOpen,
            };

        case adminAreaConstants.ORDER_IMPORT_REQUEST:
            return {
                ...state,
                orderImportResult: null,
                orderImportLoading: true,
            };

        case adminAreaConstants.ORDER_IMPORT_SUCCESS:
            return {
                ...state,
                orderImportResult: action.result,
                orderImportError: undefined,
                orderImportLoading: false,
            };

        case adminAreaConstants.ORDER_IMPORT_FAILURE:
            return {
                ...state,
                orderImportError: action.error,
                orderImportLoading: false,
            };

        case adminAreaConstants.ORDER_IMPORT_CLEANUP:
            return {
                ...state,
                orderImportResult: undefined,
                orderImportError: undefined,
                orderImportModalOpen: false,
                orderImportLoading: false,
            };

        case adminAreaConstants.SET_TEST_MODE_REQUEST:
            return {
                ...state,
                setTestModeResult: "",
            };

        case adminAreaConstants.SET_TEST_MODE_SUCCESS:
            let configurations = state.configurations;
            index = configurations.findIndex(
                (configuration) => configuration.externalUUID === action.result.externalUUID
            );
            configurations[index] = action.result;

            return {
                ...state,
                setTestModeResult: action.result,
                configurations: configurations,
            };

        case adminAreaConstants.SET_TEST_MODE_FAILURE:
            return {
                ...state,
                setTestModeResult: action.errorMessage,
            };

        case adminAreaConstants.TRIGGER_HEALTH_REPORT_REQUEST:
            return {
                ...state,
                healthReportMessage: null,
                healthReportErrorMessage: null,
            };

        case adminAreaConstants.TRIGGER_HEALTH_REPORT_SUCCESS:
            return {
                ...state,
                healthReportMessage: "HealthReport wurde erfolgreich gestartet",
            };

        case adminAreaConstants.TRIGGER_HEALTH_REPORT_FAILURE:
            return {
                ...state,
                healthReportErrorMessage: "HealthReport konnte nicht gestartet werden",
            };

        case adminAreaConstants.TRIGGER_HEALTH_REPORT_CLEANUP:
            return {
                ...state,
                healthReportMessage: null,
                healthReportErrorMessage: null,
            };

        case adminAreaConstants.LOAD_SIMPLE_ORGANIZATIONS_REQUEST:
            return {
                ...state,
                simpleOrgs: null,
            };

        case adminAreaConstants.LOAD_SIMPLE_ORGANIZATIONS_SUCCESS:
            return {
                ...state,
                simpleOrgs: action.result,
            };

        case adminAreaConstants.LOAD_SIMPLE_ORGANIZATIONS_FAILURE:
            return {
                ...state,
                simpleOrgsError: action.errorMessage,
            };

        case adminAreaConstants.LOAD_NEXT_ORGANIZATIONS:
            return {
                ...state,
                filterProperties: {
                    name: state.filterProperties.name,
                    webhooksFailingIndicator: state.filterProperties.webhooksFailingIndicator,
                    testMode: state.filterProperties.testMode,
                    page: state.filterProperties.page + 1,
                },
            };

        case adminAreaConstants.CLEAR_FILTER_PROPERTIES:
            return {
                ...state,
                filterProperties: {
                    name: "",
                    webhooksFailingIndicator: null,
                    testMode: null,
                    page: 0,
                },
            };

        case adminAreaConstants.CLEAR_STATE_ON_LOGIN:
            return {
                ...state,
                userFilterProperties: null,
                errorMessage: null,
            };

        case adminAreaConstants.GET_GLOBAL_SETTINGS_REQUEST:
            return {
                ...state,
                globalSettingsLoading: true,
                globalSettingsErrorMessage: null,
            };

        case adminAreaConstants.GET_GLOBAL_SETTINGS_SUCCESS:
            return {
                ...state,
                globalSettingsLoading: false,
                globalSettings: action.globalSettings,
            };

        case adminAreaConstants.GET_GLOBAL_SETTINGS_FAILURE:
            return {
                ...state,
                globalSettingsLoading: false,
                globalSettingsErrorMessage: action.errorMessage,
            };

        case adminAreaConstants.SAVE_GLOBAL_SETTINGS_REQUEST:
            return {
                ...state,
                globalSettingsSaveLoading: true,
                globalSettingsErrorMessage: null,
            };

        case adminAreaConstants.SAVE_GLOBAL_SETTINGS_SUCCESS:
            return {
                ...state,
                globalSettingsSaveLoading: false,
                globalSettings: action.updatedGlobalSettings,
            };

        case adminAreaConstants.SAVE_GLOBAL_SETTINGS_FAILURE:
            return {
                ...state,
                globalSettingsSaveLoading: true,
                globalSettingsErrorMessage: action.errorMessage,
            };

        case adminAreaConstants.SET_AUDITED_ORGANIZATION:
            return {
                ...state,
                audit: {
                    auditedOrganization: action.organization,
                },
            };

        case adminAreaConstants.GET_AUDIT_CHANGES_REQUEST:
            return {
                ...state,
                auditChangesLoading: true,
            };

        case adminAreaConstants.GET_AUDIT_CHANGES_SUCCESS:
            return {
                ...state,
                auditChangesLoading: false,
                audit: {
                    ...state.audit,
                    authDataChanges: action.response.authDataChanges,
                    integrationsChanges: action.response.integrationsChanges,
                },
            };

        case adminAreaConstants.GET_AUDIT_CHANGES_FAILURE:
            return {
                ...state,
                auditChangesLoading: false,
                auditChangesErrorMessage: action.errorMessage,
            };

        case adminAreaConstants.GET_ORGANIZATION_AND_USERS_AUDIT_CHANGES_REQUEST:
            return {
                ...state,
                auditChangesLoading: true,
            };

        case adminAreaConstants.GET_ORGANIZATION_AND_USERS_AUDIT_CHANGES_SUCCESS:
            return {
                ...state,
                auditChangesLoading: false,
                audit: {
                    ...state.audit,
                    organizationChanges: action.response.organizationChanges,
                    usersChanges: action.response.usersChanges,
                },
            };

        case adminAreaConstants.GET_ORGANIZATION_AND_USERS_AUDIT_CHANGES_FAILURE:
            return {
                ...state,
                auditChangesLoading: false,
                auditChangesErrorMessage: action.errorMessage,
            };

        case adminAreaConstants.SET_PARALLEL_TESTS_ORGANIZATION_REQUEST:
            return {
                ...state,
                reducedOrganization: action.organization,
            };

        case adminAreaConstants.GET_PARALLEL_TESTS_DATA_REQUEST:
            return {
                ...state,
                parallelTests: [],
                parallelTestsLoading: true,
            };

        case adminAreaConstants.GET_PARALLEL_TESTS_DATA_SUCCESS:
            return {
                ...state,
                parallelTests: action.response,
                parallelTestsLoading: false,
            };

        case adminAreaConstants.GET_PARALLEL_TESTS_DATA_FAILURE:
            return {
                ...state,
                parallelTestsErrorMessage: action.errorMessage,
                parallelTestsLoading: false,
            };

        case adminAreaConstants.EXECUTE_PARALLEL_TEST_FOR_CLIENT_AND_INTEGRATION_REQUEST:
            return {
                ...state,
            };

        case adminAreaConstants.EXECUTE_PARALLEL_TEST_FOR_CLIENT_AND_INTEGRATION_SUCCESS:
            return {
                ...state,
                parallelTestsErrorMessage: action.response,
            };

        case adminAreaConstants.EXECUTE_PARALLEL_TEST_FOR_CLIENT_AND_INTEGRATION_FAILURE:
            return {
                ...state,
                parallelTestsErrorMessage: action.errorMessage,
            };

        case adminAreaConstants.GET_REDUCED_ORGANIZATION_FOR_TESTING_REQUEST:
            return {
                ...state,
                reducedOrganizationsLoading: true,
            };

        case adminAreaConstants.GET_REDUCED_ORGANIZATION_FOR_TESTING_SUCCESS:
            return {
                ...state,
                reducedOrganizationsLoading: false,
                reducedOrganization: action.result,
                errorMessage: null,
            };

        case adminAreaConstants.GET_REDUCED_ORGANIZATION_FOR_TESTING_FAILURE:
            return {
                ...state,
                errorMessage: action.errorMessage,
                reducedOrganizationsLoading: false,
                reducedOrganization: null,
            };

        case adminAreaConstants.TOGGLE_BUG_REPORT_MODAL:
            return {
                ...state,
                bugReportModalOpen: !state.bugReportModalOpen,
                bugReportResult: null,
                bugReportError: null,
            };

        case adminAreaConstants.CREATE_BUG_REPORT_REQUEST:
            return {
                ...state,
                bugReportLoading: true,
                bugReportResult: null,
                bugReportError: null,
            };

        case adminAreaConstants.CREATE_BUG_REPORT_SUCCESS:
            return {
                ...state,
                bugReportLoading: false,
                bugReportResult: action.result,
            };

        case adminAreaConstants.CREATE_BUG_REPORT_FAILURE:
            return {
                ...state,
                bugReportLoading: false,
                bugReportError: action.errorMessage,
            };

        case adminAreaConstants.GET_ACTIVE_MILESTONES_REQUEST:
            return {
                ...state,
                milestonesLoading: true,
                milestones: null,
                milestonesError: null,
            };

        case adminAreaConstants.GET_ACTIVE_MILESTONES_SUCCESS:
            return {
                ...state,
                milestonesLoading: false,
                milestones: action.result,
                milestonesError: null,
            };

        case adminAreaConstants.GET_ACTIVE_MILESTONES_FAILURE:
            return {
                ...state,
                milestonesLoading: false,
                milestones: null,
                milestonesError: action.errorMessage,
            };

        case adminAreaConstants.GET_PROJECT_LABELS_REQUEST:
            return {
                ...state,
                projectLabelsLoading: true,
                projectLabels: null,
                projectLabelsError: null,
            };

        case adminAreaConstants.GET_PROJECT_LABELS_SUCCESS:
            return {
                ...state,
                projectLabelsLoading: false,
                projectLabels: action.result,
                projectLabelsError: null,
            };

        case adminAreaConstants.GET_PROJECT_LABELS_FAILURE:
            return {
                ...state,
                projectLabelsLoading: false,
                projectLabels: null,
                projectLabelsError: action.errorMessage,
            };

        default:
            return state;
    }
}
